var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDemanda(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.642,
    height: 16.67,
    viewBox: "0 0 17.642 16.67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_44",
    "data-name": "Grupo 44",
    transform: "translate(-135.179 -91.665)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_43",
    "data-name": "Grupo 43"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24",
    "data-name": "Caminho 24",
    d: "M148.941,92.215v5.16h-9.88v-4.4a.546.546,0,0,1,.54-.55h5.72l.51-.76h2.57A.546.546,0,0,1,148.941,92.215Z",
    fill: "#e38e31"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_25",
    "data-name": "Caminho 25",
    d: "M149.671,93.825v5.91h-11.34v-5.04a.625.625,0,0,1,.63-.62h6.55l.58-.88h2.95A.627.627,0,0,1,149.671,93.825Z",
    fill: "#eeac4a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_26",
    "data-name": "Caminho 26",
    d: "M138.315,100l-1.228,1.033L135.179,100l2.1-3.1,1.034,1.034Z",
    fill: "#2e4451"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_27",
    "data-name": "Caminho 27",
    d: "M152.821,99.995l-1.91,1.04-.19-.16-1.03-.88v-2.06l1.03-1.04Z",
    fill: "#2e4451"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_28",
    "data-name": "Caminho 28",
    d: "M150.721,95.575v7.01h-13.44v-5.98a.738.738,0,0,1,.74-.74h7.77l.69-1.04h3.5A.747.747,0,0,1,150.721,95.575Z",
    fill: "#f9ca62"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_29",
    "data-name": "Caminho 29",
    d: "M152.821,100v7.19a1.144,1.144,0,0,1-1.15,1.15h-15.34a1.144,1.144,0,0,1-1.15-1.15V100h6.78l.34,1.04h3.4l.34-1.04Z",
    fill: "#41596b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_14",
    "data-name": "Ret\\xE2ngulo 14",
    width: 5.169,
    height: 1.034,
    rx: 0.458,
    transform: "translate(141.416 103.1)",
    fill: "#f4f4f4"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_30",
    "data-name": "Caminho 30",
    d: "M152.821,100v7.19a1.144,1.144,0,0,1-1.15,1.15H144V92.425h1.32l.51-.76h2.57a.546.546,0,0,1,.54.55v.98h.1a.627.627,0,0,1,.63.63v1h.31a.747.747,0,0,1,.74.75v1.32Z",
    fill: "#282828",
    opacity: 0.1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDemanda);
export default __webpack_public_path__ + "static/media/demanda.4c0e0600620892d85754a69283da3055.svg";
export { ForwardRef as ReactComponent };